import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "swiper_box"
};
var _hoisted_2 = {
  class: "legalNotice_box container"
};
var _hoisted_3 = {
  class: "legalNotice_title"
};
var _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($setup.legalNotice.title), 1), _createElementVNode("div", {
    class: "legalNotice_text",
    innerHTML: $setup.legalNotice.content
  }, null, 8, _hoisted_4)])]);
}